module.exports = __webpack_public_path__ + "static/media/edu8.f5f6add1.jpg";